import { Reducer } from 'redux';
import { Actions } from '../../actions/Actions';
import { GPSInvestmentCreationData } from '../Models/GPSInvestmentCreation';

// TODO: old state should be replacted with AuthenticationStatusState and action should be replaced with AuthenticationAction 
export const gpsReducer: Reducer<GPSInvestmentCreationData> =
    (oldState: GPSInvestmentCreationData = initialGPSInvetmentState, action: any): GPSInvestmentCreationData => {
        let newState: GPSInvestmentCreationData;
        switch (action.type) {
            case Actions.GET_GPS_CREATION_DATA:
                newState = { ...oldState };
                break;
            case Actions.SAVE_GPS_CREATION_DATA:
                newState = action.payload;
                break;
            default:
                newState = oldState;
                break;
        }
        return newState;
    };

export const initialGPSInvetmentState: GPSInvestmentCreationData = {
    RequestersList: [],
    gpsRequestType: "",
    gpsBusiness: "",
    gpsDecisionType: "",
    gpsProduct: [],
    gpsPartnerType: [],
    gpsMultiPartnerType: [],
    gpsPartnerOneNameAssigneTo: "",
    gpsPartnerOneName: "",
    gpsPartnerOneId: 0,
    gpsPartnerContactInformation: "",
    gpsStartDate: null,
    gpsEndDate: null,
    gpsInvestmentType: "",
    gpsInvestmentAmount: 0,
    MCEMStage: "",
    OpportunityId: "",
    gpsdealEconomics: "",
    description: "",
    gpsIncRevenue: 0,
    gpsPolicy: false,
    gpsPIRReviewDate: null,
    gpsBusinessCaseURL: "",
    gpsFinancialURL: "",
    gpsAreas: [],
    gpsHandleClick: false,
    isCaseDetails: false,
    isPIRDetails: false,
    isPolicyDetails: false,
    isDocument: false,
    isFinancial: false,
    gpsSolutionArea: [],
    gpsMcemStages: [],
    gpsCustomerSegment: [],
    gpsAskType: "",
    gpsEngagementType: [],
    gpsPayoutType: [],

    // Launch Checklist Fields
    gps_custom_calc: undefined,
    gps_newdatasource: undefined,
    gps_new_poe: undefined,
    gps_partner_support: undefined,
    gps_event_mgmt: undefined,
    gps_newpc_mci_cap: undefined,
    gps_new_consent: undefined,
    gps_field_nomination: undefined,
    gps_custom_eligibility: undefined,
    gps_pc_reporting: undefined,
    gps_internal_reporting: undefined,
    gps_perf_metric: undefined,
    gps_mci_policy_update: undefined,

    // Survey Questions Fields
    gps_surveyrequestitle: undefined,
    gps_surveycontentowner: undefined,
    gps_surveyurgency: undefined,
    gps_surveytype: undefined,
    gps_surveyaudience: undefined,
    gps_surveydescription: undefined,
    gps_surveyworkshopcode: undefined,
    gps_isalreadyexistsinlocalizedcontentlibrary: undefined,
    gps_surveydisplayname: undefined,
    gps_surveyrequestedlaunchdate: undefined,
}

export const getGPSData = (dispatch: any) => {
    dispatch({
        type: Actions.GET_GPS_CREATION_DATA
    });
};

export const setGPSData = (payload: GPSInvestmentCreationData) => (dispatch: any) => {
    dispatch({
        type: Actions.SAVE_GPS_CREATION_DATA,
        payload
    });
};


// Generated by GitHub Copilot | Updated on: 2026-05-21 | Removed GL/PC Code field from create action
// Generated by GitHub Copilot | Updated on: 2026-08-14 | 1 line modified | Initialized existing partner contact field
// Generated by GitHub Copilot | Updated on: 2026-08-26 | 10 lines modified | Initialized survey state with payload field names
// Generated by GitHub Copilot | Updated on: 2026-08-27 | 1 line modified | Corrected survey audience initial state
// Generated by GitHub Copilot | Updated on: 2026-08-27 | 1 line modified | Initialized consent description state
// Generated by GitHub Copilot | Updated on: 2026-08-28 | 1 line modified | Removed consent description initial state
